module.exports = __webpack_public_path__ + "img/arbitrum-one.150db383.svg";